export default "__VITE_ASSET__mYHeUvXr__"